import { useSearchParams } from "react-router";

export const useUpdateQueryParam = () => {
    const [currentParams, setSearchParams] = useSearchParams();

    // Lista kluczy, które chcemy modyfikować (ustawiać lub usuwać)
    const allowedKeys = new Set([
        "id",
        "city",
        "street",
        "buildingNr",
        "apartmentNr",
        "parcelNumber",
    ]);

    const updateQueryParam = (key, value) => {
        // Zaczynamy od aktualnych parametrów
        const newParams = new URLSearchParams(currentParams);

        // Aktualizujemy tylko jeśli klucz należy do allowedKeys
        if (allowedKeys.has(key)) {
            if (value !== undefined && value !== null && value !== "") {
                newParams.set(key, value);
            } else {
                newParams.delete(key);
            }
        }

        // Pozostawiamy wszystkie inne parametry bez zmian
        setSearchParams(newParams);
    };

    return updateQueryParam;
};
